import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const ProtokolEdit = lazy(() =>
  import('@/modules/vozidla/ProtokolEdit').then((m) => ({ default: m.ProtokolEdit })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/vozidla/smlouvy/$id/protokol/upravit',
  component: () => (
    <Suspense fallback={null}>
      <ProtokolEdit />
    </Suspense>
  ),
});
